<script>
  import { tick, onMount} from "svelte";
  import fuzzysort from "fuzzysort";

  export let pageTitle;

 import {getProjects} from "../services/project";


  let projects;
  let projectStore;
  let vsPrefix = process.env.VIS_SITE_PREFIX;

  $: projects = $projectStore || [];
  //makes sure that the projects dont include any demo projects
  //just remove this if you want to see all projects
  $: projects = projects.filter(({notes}) => !notes.match(/^DEMO/));
  //remove all uncleaned projects (so not going to display a visualiser)
  $: projects = projects.filter(({cleanupDate}) => checkCleanupDate(cleanupDate));

  function checkCleanupDate(date){
      //check there is a cleanup date otherwise no data
      if(date != null){
          //check the clean up day was at least a day ago
          let today = new Date();
          let dayBefore = new Date(
              today.getFullYear(), 
              today.getMonth(), 
              today.getDate() - 1, 
              today.getHours(), 
              today.getMinutes());
          if(new Date(date) <= dayBefore){
            return true;
          }
          return false;
      }
      return false;
  }


  onMount(async () => {
    projectStore = await getProjects();

  })
  //could add sort button (alphabetical, data both ways ), also if there a way to limit out maps with no data 
  let keys = ["name"];
  let value = "";
  let inputEl;
  let hidden;

  $: filteredOptions = getFilteredOptions(value, projects, keys);
  $: availiableOptions = renderOptions(value, filteredOptions, projects);
  $: !hidden && focusText();

  async function focusText(hidden) {
    value = "";
    await tick();
    inputEl.focus();
  }
  function getFilteredOptions(value, options, keys) {
    const res = fuzzysort.go(value, options, { keys });
    return res;
  }
  function renderOptions(value, filteredOptions, options) {
    const visibleOptions = value ? filteredOptions.map(r => r.obj) : options;
    return visibleOptions.map((obj, i) => {
      let html = {};
      for (let y = 0; y < keys.length; y++) {
        if (filteredOptions[i] && filteredOptions[i][y]) {
          html[keys[y]] = fuzzysort.highlight(
            filteredOptions[i][y],
            "<b>",
            "</b>"
          );
        } else {
          html[keys[y]] = obj[keys[y]];
        }
      }
      let item = {
        obj,
        html
      };
      return item;
    });
  }

</script>


<section>

<div class="listSearch">
  <h1>{pageTitle}</h1>
  <div class="list-container">
      <slot name="input">
        <input type="text" bind:value bind:this={inputEl} placeholder="Search Project..."/>
      </slot>
      <ul class="list">
        {#each availiableOptions as option, i}
          <li>
              <a href="{vsPrefix}/{option.obj.slug}/network" target="_blank" rel="noopener noreferrer">
                <slot name="item" {option}>
                  {#each keys as key}
                      {@html option.html[key]}
                  {/each}
                </slot>
              </a>
          </li>
        {:else}
          <li>No Projects</li>
        {/each}
      </ul>
  </div> 

</div>


</section>